module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-f4cd67133a34f99057b5bdd38923cdae.webp";